var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modal-message",attrs:{"hide-footer":"","hide-header":"","size":"md"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"textc-primary p-4"},[_vm._v(_vm._s(_vm.message))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }